import { searchInputKey } from './search-input';
import { createDeprecatedInputDriver } from '../../primitives/deprecated-input/driver';
export var createSearchInputDriver = function (wrapper) {
    var searchInput = wrapper.$("." + searchInputKey);
    var inputField = createDeprecatedInputDriver(searchInput);
    return {
        value: function () { return inputField.value(); },
        reset: function () { return searchInput.$('.reset-search-btn').click(); },
        set: function (value) { return inputField.enterValue(value); },
        disabled: function () { return inputField.disabled(); },
        placeholder: function () { return inputField.placeholder(); }
    };
};
//# sourceMappingURL=driver.js.map